import {
  Injectable
} from '@angular/core';

import {
  HttpClient
} from '@angular/common/http';

import {
  Observable
} from 'rxjs';

import {
  environment
} from '../../environments/environment';


export interface AvaliacaoResponse {

  id: number;

  nota: number;

  comentario: string | null;

  token: string;

  criadaEm: string;

  respondidaEm: string | null;

  publicada: boolean;

  nomeHospede: string;

  quartoNome: string;

  checkIn: string;

  checkOut: string;

}


export interface AvaliacaoRequest {

  nota: number;

  comentario: string;

}


export interface AvaliacaoPublica {

  nomeHospede: string;

  nota: number;

  comentario: string | null;

  respondidaEm: string;

}


@Injectable({
  providedIn: 'root'
})
export class AvaliacaoService {

  private readonly api =
    `${environment.apiUrl}/avaliacoes`;


  constructor(
    private http: HttpClient
  ) {}


  buscarPorToken(
    token: string
  ): Observable<AvaliacaoResponse> {

    return this.http.get<AvaliacaoResponse>(
      `${this.api}/${token}`
    );

  }


  enviarAvaliacao(
    token: string,
    avaliacao: AvaliacaoRequest
  ): Observable<AvaliacaoResponse> {

    return this.http.post<AvaliacaoResponse>(
      `${this.api}/${token}`,
      avaliacao
    );

  }


  buscarAvaliacoesPublicas(
    quartoId: number
  ): Observable<AvaliacaoPublica[]> {

    return this.http.get<AvaliacaoPublica[]>(
      `${this.api}/quarto/${quartoId}`
    );

  }

}
